import SearchIcon from '@mui/icons-material/Search';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

export const whatSnagEasyData = {
  header: {
    badge: {
      text: "Why SnagEasy?",
      icon: "CheckCircleIcon"
    },
    title: "Discover Issues Before They Become Problems with Our Home Inspection Service",
    description: "Don't let snagging issues compromise the quality and safety of your home. Contact us today to schedule a comprehensive home inspection and ensure that your property is in top condition. We are the answer to solving your snagging needs, providing peace of mind and confidence in your home investment."
  },
  features: [
    {
      icon: <SearchIcon className="feature-icon" />,
      title: "Comprehensive Inspections",
      description: "Our team of experienced professionals conducts thorough inspections, leaving no stone unturned. We meticulously check every aspect of your home, ensuring that all snagging issues are identified.",
      color: "#10B981"
    },
    {
      icon: <TrendingUpIcon className="feature-icon" />,
      title: "Advanced Technology",
      description: "We use the latest technology and tools to detect even the most hidden defects. Our advanced equipment allows us to see beyond the surface, ensuring that no issue goes unnoticed.",
      color: "#3B82F6"
    },
    {
      icon: <AssessmentIcon className="feature-icon" />,
      title: "Detailed Reports",
      description: "After completing the inspection, we provide a detailed report outlining all identified issues. Our reports include photographs, descriptions, and recommendations for repairs.",
      color: "#8B5CF6"
    },
    {
      icon: <SupportAgentIcon className="feature-icon" />,
      title: "Expert Advice",
      description: "Our team of experts is always available to provide advice and guidance on addressing snagging issues. We support you every step of the way to ensure your home is safe and defect-free.",
      color: "#F59E0B"
    }
  ]
};
